import { useSelector } from 'react-redux';

import { cancellationCartApi, dedicatedChannelsCartApi } from '@reducers/order';

export function configureDedicatedChannelsCartQueries() {
  const { login } = useSelector((state) => state.auth.user);
  const [addQuery, addResult] =
    dedicatedChannelsCartApi.useAddChannelToCartMutation();
  const [removeQuery, removeResult] =
    dedicatedChannelsCartApi.useRemoveChannelFromCartMutation();
  const [clearQuery, clearResult] =
    dedicatedChannelsCartApi.useClearChannelCartMutation();
  return {
    add: { query: (did) => addQuery({ did, login }), result: addResult },
    remove: {
      query: (did) => removeQuery({ did, login }),
      result: removeResult,
    },
    clear: { query: () => clearQuery({ login }), result: clearResult },
  };
}

export function configureCancelDedicatedChannelsQueries() {
  const { login } = useSelector((state) => state.auth.user);
  const [addQuery, addResult] =
    cancellationCartApi.useAddDedicatedChannelToCartMutation();
  const [removeQuery, removeResult] =
    cancellationCartApi.useRemoveDedicatedChannelFromCartMutation();
  const [clearQuery, clearResult] =
    cancellationCartApi.useClearDedicatedChannelsCartMutation();
  const [deleteQuery, deleteResult] =
    cancellationCartApi.useDeleteChannelOrderFromCartMutation();
  return {
    add: { query: (did) => addQuery({ did, login }), result: addResult },
    remove: {
      query: (did) => removeQuery({ did, login }),
      result: removeResult,
    },
    clear: { query: () => clearQuery({ login }), result: clearResult },
    delete: { query: (id) => deleteQuery({ id, login }), result: deleteResult },
  };
}
